

  const handleIntersection = (entries, relatedObserver) => {
    if (!entries[0].isIntersecting) return;

    relatedObserver.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          var swiperRelated = new Swiper(" .recommendations__v2--slider", {
            slidesPerView: 1.2,
            spaceBetween: 16,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              640: {
                slidesPerView: 1.5,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 16,
                loop: true,
              },
              1024: {
                slidesPerView: 3.44,
                spaceBetween: 16,
              },
            },
          });
//ajax adc
var customADDtocart=document.querySelectorAll(".ajax_addtocart.custom__addtocart");
  
customADDtocart.forEach(function(ele){

ele.addEventListener("click", function(e){
        e.preventDefault()
        var getParent=ele.closest(".functional-buttons");
        console.log(getParent)
        var form=getParent.querySelector("input[name='id']");
        var varId=form.value;
        // Prepare the data to be sent to the Shopify Cart API
        const data = {
          items: [{
            id: varId,
            quantity: 1
          }]
        };
  
        // Send the fetch request to the Shopify API to add the item to the cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(cart => {
          var cartIcon= document.querySelector(".site-header__cart-toggle.js-drawer-open-right");
          cartIcon.click();

          cartIcon.click();
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        });
      });
    });



        }
      })
      .catch(e => {
        console.error(e);
      });

      
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  var relatedObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  relatedObserver.observe(productRecommendationsSection);








  

